import { render, staticRenderFns } from "./left-menu-item.vue?vue&type=template&id=5d950221&scoped=true&"
import script from "./left-menu-item.vue?vue&type=script&lang=js&"
export * from "./left-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d950221",
  null
  
)

export default component.exports